import * as scheduleRoutines from './scheduleRoutines';
import produce from 'immer';

const initialState = { listConfig: null, detailsConfig: null };
const scheduleReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case scheduleRoutines.syncSchedule.SUCCESS:
            return produce(state, draft => {
                draft.listConfig = action.payload ? action.payload.listConfig : null;
                draft.detailsConfig = action.payload ? action.payload.detailsConfig : null;
            });

        default:
            return state;
    }
};
export default scheduleReducer;
